import * as React from 'react';
import LandingPage from '../components/LandingPage/LandingPage';

const IndexPage: React.FC = () => {
  return <LandingPage />;
};

export default IndexPage;
